import { useState } from 'react';
import { NotificationsProvider } from '../contexts/NotificationsContext';
import PageHeader from './PageHeader';
import SidebarNav from './SidebarNav';

function AppLayout({ children, currentUser, onLogout }) {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  return (
    <NotificationsProvider currentUser={currentUser}>
      <div className="app-layout">
        <SidebarNav
          currentUser={currentUser}
          onLogout={onLogout}
          isMobileNavOpen={isMobileNavOpen}
          onMobileNavOpenChange={setIsMobileNavOpen}
        />
        <div className="app-content">
          <PageHeader
            currentUser={currentUser}
            onOpenMenu={() => setIsMobileNavOpen(true)}
          />
          <main className="app-main">
            {children}
          </main>
        </div>
      </div>
    </NotificationsProvider>
  );
}

export default AppLayout;
